<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { printf } from "fast-printf";

export default {
  name: 'app',
  created() {
    const ver = printf("GitHash: [%s]", process.env.IMAGE_GIT_HASH);
    const c = document.createComment(ver);
    document.body.appendChild(c);
  }
}
</script>

<style lang="scss">
@import './assets/style/common.css';
@import './assets/style/entry.css';
@import './assets/style/entry_theme_base.css';
@import './assets/style/jobs.css';
@import './assets/style/jobs_theme_base.css';
@import './assets/style/setting.css';
@import './assets/scss/setting.scss';
@import './assets/style/vue2_datepicker.css';
@import './assets/style/icon.css';

button, input, optgroup, select, textarea {
  font: unset !important;
}

input, button, select, optgroup, textarea {
  font-family: unset !important;
}
</style>
